import { addDateOnlyDays } from './date-only';
import { getTeamsForShift } from './shifts';

export const VEHICLE_UNITS = { COMPOSITE: 'Kompozit', STRUCTURAL: 'Yapısal', PAINT: 'Boya', R1_R2: 'Şeflik (ortak)' } as const;
export function vehicleSlot(now = new Date()) {
  const local = new Date(now.getTime() + 3 * 3600000);
  let date = local.toISOString().slice(0, 10);
  const hour = local.getUTCHours();
  const shift = hour >= 7 && hour < 15 ? 'SABAH' : hour >= 15 && hour < 23 ? 'OGLE' : 'GECE';
  if (hour < 7) date = addDateOnlyDays(date, -1);
  const startHour = shift === 'SABAH' ? 7 : shift === 'OGLE' ? 15 : 23;
  const start = new Date(`${date}T${String(startHour).padStart(2, '0')}:00:00+03:00`);
  const previous = shift === 'SABAH' ? 'GECE' : shift === 'OGLE' ? 'SABAH' : 'OGLE';
  const elapsed = now.getTime() - start.getTime();
  return { date, shift, team: getTeamsForShift(date, shift)[0]!, previousTeam: getTeamsForShift(shift === 'SABAH' ? addDateOnlyDays(date, -1) : date, previous)[0]!, start: start.toISOString(), overdue: elapsed >= 3600000,
    end: new Date(start.getTime() + 8 * 3600000).toISOString(), endCheckOpen: elapsed >= 7 * 3600000, endReminderDue: elapsed >= 7.5 * 3600000 };
}
